import type { TierName, TierColorConfig } from './types/whalersClub.types';

export const WHALERS_CLUB_DISMISSED_KEY = 'whalersClub:dismissed';

export const WHALERS_CLUB_TIME_ZONE = 'America/New_York';

export const TIER_COLORS: Record<TierName, TierColorConfig> = {
  Default: {
    primary: '#9E9266',
    background: '#C0B481',
    secondary: '#CACACA',
    progressGradient: 'linear-gradient(270deg, #DECF95 28.31%, #DDD19D 100%), linear-gradient(271deg, #DC9E51 93.11%, #EEB772 95.9%, #DC9E51 99.59%), linear-gradient(248deg, #BABABA 9.18%, #EEE 48.01%, #7B7B7B 88.8%), linear-gradient(130deg, #772C20 -42.73%, #9F3D2C 4.47%, #CA7561 31.37%, #ED988A 48.93%, #AA5946 71.44%)',
    modalGradient: 'linear-gradient(180deg, #CACACA 0%, rgba(255, 255, 255, 0.00) 100%)',
  },
  Bronze: {
    primary: '#673208',
    background: '#B86C59',
    secondary: '#CA806F',
    progressGradient: 'linear-gradient(90deg, #D38D7C 0%, #C67C6B 96.3%)',
    modalGradient: 'linear-gradient(180deg, #B86C59 0%, rgba(255, 255, 255, 0.00) 100%)',
  },
  Silver: {
    primary: '#1A1C1E',
    background: '#8B8B8B',
    secondary: '#9C9C9C',
    progressGradient: 'linear-gradient(248deg, #BABABA 9.18%, #D2D2D2 88.8%)',
    modalGradient: 'linear-gradient(180deg, #9C9C9C 0%, rgba(255, 255, 255, 0.00) 100%)',
  },
  Gold: {
    primary: '#9E9266',
    background: '#C0B481',
    secondary: '#D5C487',
    progressGradient: 'linear-gradient(270deg, #DECF95 28.31%, #DDD19D 100%), linear-gradient(271deg, #DC9E51 93.11%, #EEB772 95.9%, #DC9E51 99.59%), linear-gradient(248deg, #BABABA 9.18%, #EEE 48.01%, #7B7B7B 88.8%), linear-gradient(130deg, #772C20 -42.73%, #9F3D2C 4.47%, #CA7561 31.37%, #ED988A 48.93%, #AA5946 71.44%)',
    modalGradient: 'linear-gradient(180deg, #D5C487 0%, rgba(255, 255, 255, 0.00) 100%)',
  },
  Diamond: {
    primary: '#FFFFFF',
    background: '#474A53',
    secondary: '#0C0C0C',
    progressGradient: 'linear-gradient(270deg, #464A53 28.31%, #77787A 100%), linear-gradient(271deg, #DC9E51 93.11%, #EEB772 95.9%, #DC9E51 99.59%), linear-gradient(248deg, #BABABA 9.18%, #EEE 48.01%, #7B7B7B 88.8%), linear-gradient(130deg, #772C20 -42.73%, #9F3D2C 4.47%, #CA7561 31.37%, #ED988A 48.93%, #AA5946 71.44%)',
    modalGradient: 'linear-gradient(180deg, #0C0C0C 0%, rgba(26, 28, 30, 0.00) 100%)',
  },
};
